// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"_1RFh4j","optionsTitle":"_2fulDb","dialogCloseButton":"_1wFhPd","dialogCloseButtonIcon":"Hd3Lmy","choiceWrapper":"_2aVL7L"};